<template>
<div id="salesmanList">
    <!-- 查询选项 -->
    <Form class="salesmanForm" :label-width="100">
      <FormItem class="form_item" :label="$t('conditionGroupName')">
        <Input  clearable size="default"  v-model="groupName" :placeholder="$t('enter')"/>
      </FormItem>
      <!-- <FormItem class="form_item" :label="$t('country')" prop="remark"> 
        <el-select  v-model="remark" filterable clearable :placeholder="$t('select')"  class="country"> 
          <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
        </el-select>
      </FormItem> -->
      <div class="buttonDiv">
        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchGroupList">{{$t('search')}}</el-button>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="addGroup">{{$t('add')}}</el-button>
      </div>
    </Form>
     <div class="contentTableDiv">
         <el-table :data="tableData" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" >
            <el-table-column prop="id" v-if="false"></el-table-column>
            <el-table-column prop="sysValue" :label="$t('groupName')" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="sysDesc" :label="$t('groupDescripe')" align="center"></el-table-column>
            <el-table-column prop="empName" label="Group Leader" align="center">
              <template slot-scope="scope">
                {{ (scope.row.empName || '') + ' ' + (scope.row.empCode || '') }}
             </template>
            </el-table-column>
            <!-- <el-table-column prop="remark" :label="$t('country')" align="center"></el-table-column> -->
            <el-table-column :label="$t('operate')" align="center" fixed="right"  width="400">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button>
                <el-button size="mini" type="success" @click="groupToMenu(scope.row)">{{$t('operateGroup')}}</el-button>
             </template>
            </el-table-column>
        </el-table> 
    </div>
    <div class="pageDiv">
      <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pageSize"
         layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <!--新增-->
    <Modal v-model="modelAdd" :closable='false' :mask-closable='false' :title="$t('addGroupInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="add">{{$t('confrim')}}</Button>
      </div>
      <Form  ref="addGroupForm"  :label-width="150">
        <FormItem :label="$t('conditionGroupName')" prop="postDes">
          <Input  v-model="addGroupForm.groupName" size="small" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem :label="$t('conditionGroupDes')" prop="postDes">
          <Input v-model="addGroupForm.description" size="small" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem label="Group Leader"  prop="empCode">
          <el-select v-model="addGroupForm.empCode" clearable filterable remote :remote-method="remoteMethod" :placeholder="$t('select')">
            <el-option v-for="(item, index) in userList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <!-- <FormItem :label="$t('country')" prop="remark"> 
          <el-select  v-model="addGroupForm.remark" filterable multiple clearable :placeholder="$t('select')"  class="country"> 
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue" ></el-option>
          </el-select>
        </FormItem> -->
      </Form>
    </Modal>
    <!--修改--> 
    <Modal v-model="modelUpdate" :closable='false' :mask-closable='false' :title="$t('updateGroupInfo')">
      <div slot="footer">
        <Button type="primary" size="small" @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="ok">{{$t('confrim')}}</Button>
      </div>
      <Form ref="updateGroupForm"  :label-width="150" >
        <FormItem :label="$t('conditionGroupName')" prop="postDes">
          <Input  v-model="updateGroupForm.groupName" disabled size="small" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem :label="$t('conditionGroupDes')" prop="postDes">
          <Input v-model="updateGroupForm.description" size="small" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem label="Group Leader" prop="empCode">
          <el-select v-model="updateGroupForm.empCode" clearable filterable remote :remote-method="remoteMethod" :placeholder="$t('select')">
            <el-option v-for="(item, index) in userList.slice(0, 10)" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <!-- <FormItem :label="$t('country')" prop="remark"> 
          <el-select  v-model="updateGroupForm.remark" filterable multiple clearable :placeholder="$t('select')"  class="country"> 
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue" ></el-option>
          </el-select>
        </FormItem> -->
      </Form>
    </Modal>
  </div>
</template>
<style>
  
</style>
<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'group',
        created () {
          this.getCountryList();//获取国家列表
          this.getGroupList();//获取组列表
          this.getAllMenu();//获取所有菜单作为展开项
          this.getUserList();
        },
        data () {
            return {
              groupId:null,
              groupName:null,
              // remark:null,
              currentPage: 1,
              totalCount: 0,
              pageSize: 10,
              tableData: [],
              addGroupForm:{
                groupName:null,
                description:null,
                empCode:null,
                // remark:[],
              },
              modelAdd: false,
              updateGroupForm:{
                groupName:null,
                description:null,
                empCode:null,
                // remark:[],
              },
              modelUpdate:false,           
              treeExpandedKeys:[],//展开项
              CountryList: [],
              userList: [],
              rangeNumber: 10,
            }
        },
        methods: {
          //远程搜索方法
          remoteMethod(query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(query)
              }, 200)
            } else {
              this.userList = [];
            }
          },
          fetchUserOptions(query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this.userList = res.data;
              } else {
                this.userList = [];
              }
            }).catch(error => {
              this.userList = [];
              console.error('搜索失败:', error)
            })
          },
            getCountryList(){
            let url =`${this.$store.state.islhurl}groupinfo/getCountry`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
            getGroupList(){
              let url = `${this.$store.state.islhurl}getGroupList/${this.pageSize}/${this.currentPage}`
              let pm = {
                sysValue: this.groupName, 
                delStatus: 0, 
                islhToken: sessionStorage.getItem('islhtoken')
              }
              console.log(url);
              console.log(pm);
              this._post(url,pm).then(
                res =>{
                  console.log(res);
                  this.tableData =res.data
                  this.totalCount = res.totalNums
                }
              )
            },
            searchGroupList(){
              this.pageSize = 10;
              this.currentPage = 1;
              let url = `${this.$store.state.islhurl}getGroupList/${this.pageSize}/${this.currentPage}`
              let pm = {
                sysValue: this.groupName, 
                delStatus: 0, 
                // remark:this.remark?this.remark:null,
              }
              this._post(url,pm).then(
                res =>{
                  this.tableData =res.data
                  this.totalCount = res.totalNums
                }
              )
            },
            getAllMenu(){
              let url = `${this.$store.state.islhurl}getAllMenu`             
              this._get(url).then(
                res => {      
                  this.treeExpandedKeys = res;
                }
              )
            },
            addGroup(){
              this.addGroupForm.groupName = null;
              this.addGroupForm.description = null;
              // this.addGroupForm.remark = [];
              this.modelAdd = true
            },
            add(){
              if(this.addGroupForm.groupName === null || this.addGroupForm.groupName === ''){
                var msg = this.$t('groupNameNull');
                this.$Message.error(msg);
                return;
              }
              if(this.addGroupForm.description === null || this.addGroupForm.description ===''){
                var msg = this.$t('groupDesNull');
                this.$Message.error(msg);
                return;
              }
              if(this.addGroupForm.empCode === null || this.addGroupForm.empCode ===''){
                var msg = 'Group leader cannot be empty.';
                this.$Message.error(msg);
                return
              }
              // if(this.addGroupForm.remark === null || this.addGroupForm.remark ===[] || this.addGroupForm.remark.length ===0){
              //   var msg = this.$t('countryNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // const countryList = this.addGroupForm.remark?this.addGroupForm.remark.join(','):null
              let params = {
                sysValue: this.addGroupForm.groupName,
                sysDesc : this.addGroupForm.description,
                empCode : this.addGroupForm.empCode,
                // remark: countryList,
              }
              let url = `${this.$store.state.islhurl}addGroup`
              this._post(url,params).then(
                res => {
                  if(res == '200'){
                    this.modelAdd = false;
                    this.getGroupList()
                    var msg = this.$t('saveSus');
                    this.$Message.success(msg);
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
              
            },
            handleEdit(index) {
              this.id = index.id
              this.updateGroupForm.groupName = index.sysValue
              this.updateGroupForm.description = index.sysDesc
              this.updateGroupForm.empCode = index.empCode
              // this.updateGroupForm.remark = index.remark?index.remark.split(','):[]
              this.modelUpdate = true;
              if(index.empCode) {
                this.remoteMethod(index.empCode)
              }
            },
            //修改Group信息确认
            ok(){
              if(this.updateGroupForm.groupName === null || this.updateGroupForm.groupName === ''){
                var msg = this.$t('groupNameNull');
                this.$Message.error(msg);
                return
              }
              if(this.updateGroupForm.description === null || this.updateGroupForm.description ===''){
                var msg = this.$t('groupDesNull');
                this.$Message.error(msg);
                return
              }
              if(this.updateGroupForm.empCode === null || this.updateGroupForm.empCode ===''){
                var msg = 'Group leader cannot be empty.';
                this.$Message.error(msg);
                return
              }
              // if(this.updateGroupForm.remark === null || this.updateGroupForm.remark === [] || this.updateGroupForm.remark===''|| this.updateGroupForm.remark.length===0){
              //   var msg = this.$t('countryNull');
              //   this.$Message.error(msg);
              //   return;
              // }
              // const countryList = this.updateGroupForm.remark?this.updateGroupForm.remark.join(','):null
              let params = {
                id: this.id,
                sysValue : this.updateGroupForm.groupName,
                sysDesc: this.updateGroupForm.description,
                empCode : this.updateGroupForm.empCode,
                // remark: countryList,
              }
              let url = `${this.$store.state.islhurl}updateGroup`
              this._post(url,params).then(
                res => {
                   if(res == 'SUCCESS'){
                    this.modelUpdate = false;
                    this.getGroupList();
                    var msg = this.$t('modifySus');
                    this.$Message.success(msg);
                   }
                   else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }

                }
              )   
            },
           
            groupToMenu(index) {
            let pm = {
             groupId:index.id,
            }
            this.$router.push({name:'group_edit',params:pm})
          },
            
            //删除组
            handleDelete(index){
              var msg1 = this.$t('delMsg');
              var msg2 = this.$t('warnMsg');
              var msg3 = this.$t('confrim');
              var msg4 = this.$t('cancle');
              this.$confirm(msg1, msg2, {
                confirmButtonText: msg3,
                cancelButtonText: msg4,
                type: 'warning'
              }).then(() => {
                let url = `${this.$store.state.islhurl}delGroup?id=${index.id}`
                this._post(url).then(
                  res =>{
                    var msg = this.$t('delSus');
                    this.$Message.success(msg);
                    this.getGroupList();
                  }
                )
              }).catch(() => {
              }); 
            },

            cancel(){
              this.modelAdd = false;
              this.modelUpdate = false;
            },
            // 分页
            changePage (val) {
              this.currentPage = val
              this.getGroupList();
            },
            // 改变当前页显示条数
            changePageSize (val) {
              this.pageSize = val
              this.getGroupList();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/group/groupInfo.vue